module.exports = __webpack_public_path__ + "img/habitat.934ee94.png";